var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IxVectorLayer',{attrs:{"layer-id":"actions","features":_vm.actionFeatures,"vector-style":_vm.styles.action}}),_c('IxVectorLayer',{attrs:{"layer-id":"borders","features":_vm.borderFeatures,"vector-style":_vm.styles.border}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }